<template>

    <div class="card card-testimonial mt-5">
        <div class="card-avatar">
            <img :src="userPicture" style="width:100px;height:100px;">
        </div>
        <div :class="'card-body mt-0 pt-0 text-'+align">
            <slot></slot>
        </div>
    </div>
    
</template>

<script>
    export default {

        props: {
            id: {default: 'trax-account-user-edit'},
            align:  {default: 'left'},
            endpoint: {default: app_url + 'polaris/api/front/users'},
            disabled: null
        },

        data: function() {
            return {
                userPicture: app_url + 'polaris/img/lib/misc/avatar.jpg',
                userId: null,
                bus: this.$bus
            };
       },

        created: function() {
            this.bus.$on(this.id+'-data', this.setData);
        },

        methods: {

            setData(data) {
                this.userId = data.id;
                if (data.avatar) this.userPicture = data.avatar;
            },
        }
    }
</script>

